import { Actie } from "@/entities/actie";
import { VestigingenActie } from "@/entities/actie/domain/vestigingen";
import { Button, TimelineCard } from "@/shared/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import { ActieDialog } from "./dialogs";

type ActieTijdlijnCardProps = {
    dossierId: string;
    actie: Actie;
};

export function ActieTijdlijnCard({ actie, dossierId }: Readonly<ActieTijdlijnCardProps>) {
    const [openActieDialog, setOpenActieDialog] = useState(false);
    const navigate = useNavigate();

    const handleActionClick = () => {
        if (Actie.isVestigingActie(actie)) {
            void navigate(`/dossier/${dossierId}/faciliteiten`);
        } else if (Actie.isLandelijkeFaciliteitenActie(actie)) {
            void navigate(`/dossier/${dossierId}/landelijke-faciliteiten`);
        } else if (Actie.isBusEvacuatieActie(actie)) {
            void navigate(`/dossier/${dossierId}/betrokken-treinen?treinId=${actie.treinId}`);
        } else if (Actie.isTvvActie(actie)) {
            void navigate(`/dossier/${dossierId}/tvv?routeId=${actie.besteldeRouteId}`);
        } else {
            setOpenActieDialog(true);
        }
    };

    return (
        <TimelineCard className="flex flex-col gap-3" data-testid={`actie-list-item-${actie.type}`}>
            <div className="flex flex-col">
                <span className="text-m leading-l text-content-default">{actie.timelineContent.titel}</span>
                <span className="text-s leading-l text-content-subtle">{actie.timelineContent.beschrijving}</span>
            </div>
            <Button className="self-start" variant="primary" size="s" onClick={handleActionClick}>
                {actie.timelineContent.actieTekst}
            </Button>

            {!VestigingenActie.isVestigingActie(actie) && !Actie.isBusEvacuatieActie(actie) && !Actie.isTvvActie(actie) && (
                <ActieDialog.Factory open={openActieDialog} onOpenChange={setOpenActieDialog} dossierId={dossierId} actie={actie} />
            )}
        </TimelineCard>
    );
}
